import { makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

export interface IEmployeeGroup {
  id: number
  main: boolean
  name: string
  legal_entity_id: number
  metadata: IEmployeeGroupSpainMetadata | Record<string, never>
}

export interface IEmployeeGroupSpainMetadata {
  id: number
  es_cccs_id: string
  employee_group_id: number
  payroll_agreements_id: number
}

class EmployeeGroup extends Model<IEmployeeGroup> {
  static urlRoot() {
    return '/employee_groups'
  }

  constructor(attr: IEmployeeGroup) {
    super(attr)
    makeObservable(this, {})
  }
}

export default EmployeeGroup
